import React, { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Panel } from "../../reusable-components/MultipleTabs/interfaces";
import useQuery from "../../custom-hooks/useQuery/useQuery";
import MultipleTabs from "../../reusable-components/MultipleTabs/MultipleTabs";
import HeaderPortal from "../../containers/TableHeader/HeaderPortal";
import ProformaEmployeeCostReportTable from "./ProformaEmployeeCostReport/ProformaEmployeeCostReportTable";
import useAuthorization from "../../custom-hooks/useAuthorization/useAuthorization";
import { AUTHORIZATIONS } from "../../utils/constants/authorization-constants";

enum EmployeeCostReportRoutes {
  PROFORMA_EMPLOYEE_COST_REPORT = "proforma-employee-cost-report",
}

const EmployeeCostReportPage = () => {
  const { t } = useTranslation();
  const tRP = "pages.employee_cost_report_page.tables";
  let query = useQuery();

  const checkPanelAccess = useCallback((showPanel: boolean, panel: Panel) => (showPanel ? [panel] : []), []);

  const hasAccess = useAuthorization([
    AUTHORIZATIONS.LegalEntityAccess.ProcessAccounting,
    AUTHORIZATIONS.LegalEntityAccess.ProcessPayroll,
    AUTHORIZATIONS.LegalEntityAccess.RunAccountingReports,
  ]);

  const panels: Panel[] = useMemo(
    () => [
      ...checkPanelAccess(hasAccess, {
        tabLabel: t(`${tRP}.proforma_employee_cost_report.tab_label`),
        routePath: EmployeeCostReportRoutes.PROFORMA_EMPLOYEE_COST_REPORT,
        tabPanelComponent: <ProformaEmployeeCostReportTable />,
        tableTitle: t(`${tRP}.proforma_employee_cost_report.table_title`),
      }),
    ],
    []
  );

  const selectedTab = useMemo(() => {
    const foundIndex = panels.findIndex((panel) => panel.routePath === query.get("tab"));
    return foundIndex > -1 ? foundIndex : 0;
  }, [query, panels]);

  return (
    <>
      <HeaderPortal title={panels[selectedTab].tableTitle} />
      <MultipleTabs
        panels={panels}
        selectedTab={selectedTab}
      />
    </>
  );
};
export default EmployeeCostReportPage;
